import { render, staticRenderFns } from "./form_pedido.vue?vue&type=template&id=6e65601c"
import script from "./form_pedido.vue?vue&type=script&lang=js"
export * from "./form_pedido.vue?vue&type=script&lang=js"
import style0 from "./form_pedido.vue?vue&type=style&index=0&id=6e65601c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports